import { UniversalToggle } from '@practium/ui';
import { formatDateFromISO } from '@practium/shared';
import { Policy } from '../../types/policy.types';
import { formatPolicyVersion } from '../../utils';
import { PolicyMetaButton } from '../Buttons/PolicyMetaButton';
import styles from './PolicyCard.module.css';

interface PolicyCardProps {
	policy: Policy;
	isSelected: boolean;
	isUpdating: boolean;
	onToggle: (policyId: string, isActive: boolean) => void;
	onClick: () => void;
}

export const PolicyCard = ({
	policy,
	isSelected,
	isUpdating,
	onToggle,
	onClick,
}: PolicyCardProps) => {
	const handleToggle = (checked: boolean) => {
		onToggle(policy._id, checked);
	};

	return (
		<div
			className={`${styles.card} ${policy.isActive ? styles.active : ''} ${isSelected ? styles.selected : ''}`}
			onClick={onClick}
		>
			<div className={styles.header}>
				<h3 className={styles.title}>{policy.title}</h3>
			</div>

			<p className={styles.description}>{policy.description}</p>

			<div className={styles.footer}>
				<PolicyMetaButton variant="version">
					Versão {formatPolicyVersion(policy.versionNumber)}
				</PolicyMetaButton>
				<PolicyMetaButton variant="date">{formatDateFromISO(policy.effectiveDate)}</PolicyMetaButton>
			</div>
			<div className={styles.toggleWrapper}>
				<UniversalToggle
					className={styles.toggle}
					checked={policy.isActive}
					onChangeToggle={handleToggle}
					isLoading={isUpdating}
					onClick={(e) => e.stopPropagation()}
				/>
			</div>
		</div>
	);
};
